/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React, { useState } from 'react'

import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import CustomIcons from '../icons/CustomIcons';
import Zoom from '@material-ui/core/Zoom';
import DarkTooltip from './DarkTooltip';

const useStyles = makeStyles((theme) => ({
    textArea: {
        width: 'auto',
        paddingRight: 0,
        paddingLeft: '10px',
        backgroundColor: '#F7F8FB',
        letterSpacing: 1,
        color: '#8D91A3',
    },
 
    copyIconButton: {
        height: '48px',
        width: '48px',
        padding: 0
    },
}));

interface CopyTextAreaProps {
    textContent: string,
    rows?: number,
}

function CopyTextArea(props: CopyTextAreaProps) {
    const classes = useStyles();
    const [copiedTooltipVisible, setCopiedTooltipVisible] = useState(false);
    const textContent:string  = props.textContent;

    const handleCopyClick = (event: any) => {
        navigator.clipboard.writeText(textContent);
        setCopiedTooltipVisible(true);
        setTimeout(() => {
            setCopiedTooltipVisible(false);
        }, 2000);
    }

    return (
       
            <TextField
               id="outlined-textarea"
               placeholder="Sample Text"
               multiline
               InputProps={{
                   endAdornment:
                   <DarkTooltip title={'Copied'} TransitionComponent={Zoom} placement="right" open={copiedTooltipVisible}>
                       <IconButton onClick={handleCopyClick} className={classes.copyIconButton}>
                           <CustomIcons icon={'copy-icon'} />
                       </IconButton>
                   </DarkTooltip>,
                   classes: {
                       root: classes.textArea
                   },
               }}
               value={textContent}
               rows={props.rows || 7}
               variant="outlined"
               fullWidth
               disabled={true}
            />
       
    )
}

export default CopyTextArea;
